module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_nhnpixelcube.974cdc6640f465d9c22021b3df69b48f.png";